import { createFeatureSelector } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import {
  AffiliationTypeActions,
  AffiliationTypeActionTypes,
} from '../_actions/affiliation-type.actions';
import { QueryParamsModel } from '../../_base/crud';
import { AffiliationType } from '../_models/affiliation-type.model';

export interface AffiliationTypesState extends EntityState<AffiliationType> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedAffiliationTypeId: number;
  lastQuery: QueryParamsModel;
  error: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<AffiliationType> = createEntityAdapter<AffiliationType>({
  selectId: (lesson) => lesson.affiliation_type_id,
});

export const initialAffiliationTypesState: AffiliationTypesState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedAffiliationTypeId: undefined,
  showInitWaitingMessage: true,
});

export function affiliationTypesReducer(
  state = initialAffiliationTypesState,
  action: AffiliationTypeActions,
): AffiliationTypesState {
  switch (action.type) {
    case AffiliationTypeActionTypes.AffiliationTypesPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedAffiliationTypeId: undefined,
      };
    case AffiliationTypeActionTypes.AffiliationTypesActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case AffiliationTypeActionTypes.AffiliationTypeOnServerCreated:
      return {
        ...state,
      };
    case AffiliationTypeActionTypes.AffiliationTypeOnServerUpdated:
      return {
        ...state,
      };
    case AffiliationTypeActionTypes.AffiliationTypeOnServerDeleted:
      return {
        ...state,
      };
    case AffiliationTypeActionTypes.AffiliationTypeCreated:
      return adapter.addOne(action.payload.affiliationType, {
        ...state,
        lastCreatedAffiliationTypeId: action.payload.affiliationType.id,
      });
    case AffiliationTypeActionTypes.AffiliationTypeDeleted:
      return adapter.removeOne(action.payload.id, state);
    case AffiliationTypeActionTypes.AffiliationTypesPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case AffiliationTypeActionTypes.AffiliationTypesPageLoaded: {
      return adapter.addMany(action.payload.affiliationTypes, {
        ...initialAffiliationTypesState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        listLoading: false,
        showInitWaitingMessage: false,
      });
    }
    case AffiliationTypeActionTypes.ThrowAffiliationTypeError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case AffiliationTypeActionTypes.ClearAffiliationTypeErrors: {
      return {
        ...state,
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getAffiliationTypeState =
  createFeatureSelector<AffiliationTypesState>('affiliationTypes');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
